import React from 'react';

import ProductEditForm from '@components/shared/products/ProductEdit';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';
import useRecordMerchantSync from '@hooks/operator/useRecordMerchantSync';

// 編輯模式：useRecordMerchantSync 由 onProductLoaded 拿到 record's merchant_id 後
// 同步 OperatorDataContext.currentMerchant；整個過程 merchantDataLoading 為 true
// 擋住 form 渲染，避免 brand / merchant-scoped 下拉先以前一個 merchant render。
// （路由 /products/:id/edit 必帶 id；/products/new 走 New.tsx，無需在此處 fallback。）
const OperatorProductEdit: React.FC = () => {
  const { recordMerchantId, handleRecordLoaded, merchantDataLoading } = useRecordMerchantSync();

  return (
    <ProductEditForm
      useProductService={useOperatorProductService}
      role="operator"
      merchantId={recordMerchantId}
      onProductLoaded={handleRecordLoaded}
      merchantDataLoading={merchantDataLoading}
    />
  );
};

export default OperatorProductEdit;
